"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _accountDetails = require("@/api/shoppingGift/accountDetails");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Account',
  data: function data() {
    return {
      queryData: {
        memberId: null,
        nickname: null,
        phone: null,
        inviteCode: null,
        pageNo: 1,
        limit: 10
      },
      tableData: [],
      total: 0,
      dialogVisible: false,
      titleTxt: '',
      changeType: 1,
      // 充值1，扣款2
      findByPhoneData: {},
      ruleForm: {
        phone: '',
        memberId: null,
        platformDeductMoney: null,
        remark: null
      },
      rules: {
        phone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }],
        platformDeductMoney: [{
          required: true,
          message: '请输入金额',
          trigger: 'blur'
        }],
        remark: [{
          required: true,
          message: '请输入备注原因',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.getTljChangeRecord();
  },
  methods: {
    getTljChangeRecord: function () {
      var _getTljChangeRecord2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context.n = 1;
              return (0, _accountDetails.getTljChangeRecord)(params);
            case 1:
              res = _context.v;
              this.tableData = res.data.data;
              this.total = res.data.total;
              console.log('res', res);
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getTljChangeRecord() {
        return _getTljChangeRecord2.apply(this, arguments);
      }
      return getTljChangeRecord;
    }(),
    onInquire: function onInquire() {
      this.queryData.pageNo = 1;
      this.queryData.limit = 10;
      this.getTljChangeRecord();
    },
    onInitialize: function onInitialize() {
      this.queryData = {
        memberId: null,
        nickname: null,
        phone: null,
        inviteCode: null,
        pageNo: 1,
        limit: 10
      };
      this.getTljChangeRecord();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.limit = val;
      this.getTljChangeRecord();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.pageNo = val;
      this.getTljChangeRecord();
    },
    onRecharge: function onRecharge() {
      this.changeType = 1;
      this.dialogVisible = true;
      this.titleTxt = '淘礼金充值';
    },
    onDeduction: function onDeduction() {
      this.titleTxt = '淘礼金扣款';
      this.changeType = 2;
      this.dialogVisible = true;
    },
    onShareUser: function onShareUser() {
      if (this.ruleForm.phone === '') {
        this.$message('请输入手机号');
        return false;
      }
      this.findByPhone();
    },
    // 查询
    findByPhone: function () {
      var _findByPhone2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              params = {
                phone: this.ruleForm.phone
              };
              _context2.n = 1;
              return (0, _accountDetails.findByPhone)(params);
            case 1:
              res = _context2.v;
              this.findByPhoneData = res.data;
              this.ruleForm.memberId = res.data.memberId;
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function findByPhone() {
        return _findByPhone2.apply(this, arguments);
      }
      return findByPhone;
    }(),
    // 充值
    platformTopUp: function () {
      var _platformTopUp2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              params = {
                memberId: this.ruleForm.memberId,
                money: this.ruleForm.platformDeductMoney,
                remark: this.ruleForm.remark
              };
              _context3.n = 1;
              return (0, _accountDetails.platformTopUp)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0 && res.data) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.SuccessfulCallback();
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function platformTopUp() {
        return _platformTopUp2.apply(this, arguments);
      }
      return platformTopUp;
    }(),
    // 扣款
    platformDeductMoney: function () {
      var _platformDeductMoney2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              params = {
                memberId: this.ruleForm.memberId,
                platformDeductMoney: this.ruleForm.platformDeductMoney,
                remark: this.ruleForm.remark
              };
              _context4.n = 1;
              return (0, _accountDetails.platformDeductMoney)(params);
            case 1:
              res = _context4.v;
              if (res.code === 0 && res.data) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.SuccessfulCallback();
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function platformDeductMoney() {
        return _platformDeductMoney2.apply(this, arguments);
      }
      return platformDeductMoney;
    }(),
    SuccessfulCallback: function SuccessfulCallback() {
      this.queryData.pageNo = 1;
      this.queryData.limit = 10;
      this.onClose();
      this.getTljChangeRecord();
    },
    // 用户详情
    onUserDetails: function onUserDetails(value) {
      this.$router.push({
        path: '/member/userDetails',
        query: {
          memberId: value.memberId,
          nickname: value.nickName
        }
      });
    },
    onClose: function onClose() {
      this.findByPhoneData = {};
      this.ruleForm = {
        phone: '',
        memberId: null,
        platformDeductMoney: null,
        remark: null
      };
      this.resetForm('ruleForm');
      this.dialogVisible = false;
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (!_this.ruleForm.memberId) {
            _this.$message('请先搜索用户');
            return;
          }
          _this.$confirm("\u662F\u5426\u5411\u8BE5\u8D26\u6237".concat(_this.changeType === 1 ? '充值' : '扣除', "\u6DD8\u793C\u91D1?"), '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            if (_this.changeType === 1) {
              _this.platformTopUp();
            } else {
              _this.platformDeductMoney();
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};